import {RRTruckType} from "../../types/RRTruckType";
import {QueryDocumentSnapshot, SnapshotOptions, DocumentData} from 'firebase/firestore';

export const trucksFBConverter = {
    fromFirestore: (snapshot: QueryDocumentSnapshot, options?: SnapshotOptions): RRTruckType => {
        const data = snapshot.data(options) as Partial<RRTruckType>;
        const truck: RRTruckType = {
            id: snapshot.id,
            name: data.name ?? '',
            plate: data.plate ?? '',
            isOwn: data.isOwn ?? true,
            consumption: data.consumption ?? 0,
            lastKm: data.lastKm ?? 0,
            isActive: data.isActive ?? true
        } as RRTruckType;
        return truck;
    },
    toFirestore: (truck: RRTruckType): DocumentData => {
        return {
            name: truck.name,
            plate: truck.plate,
            isOwn: truck.isOwn,
            consumption: truck.consumption,
            lastKm: truck.lastKm,
            isActive: truck.isActive
        };
    }
};
